// extracted by mini-css-extract-plugin
export var $animation_name = "Gallery-module--$animation_name--59f3c";
export var Gallery = "Gallery-module--Gallery--e37a1";
export var GalleryMasonry = "Gallery-module--GalleryMasonry--0a2d4";
export var GalleryMasonry__grid = "Gallery-module--GalleryMasonry__grid--78f16";
export var GalleryScroll = "Gallery-module--GalleryScroll--f8a59";
export var GalleryScroll__container = "Gallery-module--GalleryScroll__container--96b49";
export var GalleryScroll__header = "Gallery-module--GalleryScroll__header--521a8";
export var GalleryScroll__header___left = "Gallery-module--GalleryScroll__header___left--d7d58";
export var GalleryScroll__header___right = "Gallery-module--GalleryScroll__header___right--68125";
export var GalleryScroll__inner = "Gallery-module--GalleryScroll__inner--05ff6";
export var Gallery___single = "Gallery-module--Gallery___single--b88bc";
export var VideoContainer = "Gallery-module--VideoContainer--1076b";